import { TimflowSteadyForm } from "../../types/forms/capture";

const clean = (v: any): any => {
  if (Array.isArray(v)) return v.map(clean);
  if (v && typeof v === "object") {
    return Object.fromEntries(
      Object.entries(v)
        .map(([k, val]) => [k, clean(val)])
        .filter(
          ([, val]) => val !== undefined && val !== "" && !Number.isNaN(val),
        ),
    );
  }
  return v;
};

const isValid = (n?: number) => n !== undefined && !Number.isNaN(n);

export const buildTimflowPayload = (values: TimflowSteadyForm) => {
  const { model, uflowEnabled, uflow, wells, constants, recharge, rivers, captureZone } = values;
  const z = model.z.map((p) => p.value).filter(isValid);

  return clean({
    model: { ...model, z: z.length ? z : undefined },
    uflow: uflowEnabled ? uflow : undefined,
    constants: constants.length ? constants : undefined,
    recharge: recharge.length ? recharge : undefined,
    rivers: rivers.length
      ? rivers.map((r) => ({ ...r, xy: r.xy.map((p) => [p.x, p.y]) }))
      : undefined,
    wells,
    captureZone: {
      ...captureZone,
      silent: captureZone.silent === "." ? "." : captureZone.silent === "true",
    },
  });
};